import React from 'react';
import { LucideIcon } from 'lucide-react';
import { cn } from '../../utils/cn';

/**
 * Icon size variants
 */
type IconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

/**
 * Props for Icon component
 */
interface IconProps {
  /** Lucide icon component */
  icon: LucideIcon;
  /** Size variant */
  size?: IconSize;
  /** Additional CSS classes */
  className?: string;
}

/**
 * Icon size class mapping
 */
const iconSizeClasses: Record<IconSize, string> = {
  xs: 'h-3 w-3',
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
  xl: 'h-8 w-8',
};

/**
 * Icon component wrapper for consistent Lucide icon usage
 * Provides unified API for icon sizing and styling
 */
const Icon: React.FC<IconProps> = ({ 
  icon: IconComponent, 
  size = 'md', 
  className,
  ...props 
}) => {
  return (
    <IconComponent 
      className={cn(iconSizeClasses[size], className)} 
      {...props}
    />
  );
};

export default Icon;
export type { IconProps, IconSize };

